<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full" :label="__('Department')" :required="true">
                          <option :value="null" />
                          <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " label="Name" />
          <select-input v-model="form.ticket_department_id" :error="form.errors.ticket_department_id" class="pr-6 pb-8 w-full" label="Departamento">
                          <option :value="null" />
                          <option v-for="d in ticket_departments" :key="d.id" :value="d.id">{{ d.name }}</option>
          </select-input>
<!--          <text-input v-model="form.color" :error="form.errors.color" class="pr-6 pb-8 w-full lg:w-1/2 color-picker" label="Color" />-->

            <label class="flex toggle_swtich items-center cursor-pointer mb-5">
                  <span class="form-label block mr-5">Privado</span>
                  <div class="relative">
                      <input type="checkbox" class="sr-only" v-model="form.private" />
                      <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                      <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                  </div>
            </label>

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear departamento</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/inertia-vue3'
import SelectInput from '@/Shared/SelectInput'
export default {
  metaInfo: { title: 'Crear departamento' },
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
    SelectInput
  },
  layout: Layout,
  props: {
      title: String,
      departments : Array,
      ticket_departments : Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        color: null,
        private: false,
        department_id : null,
        ticket_department_id : null
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('categories.store'))
    },
  },
}
</script>
